import WidgetGettingStarted from './WidgetGettingStarted';

export default WidgetGettingStarted;
